import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useCompare } from "../lib/compare";
import { Button } from "./ui/button";
import { GitCompareArrows, X } from "lucide-react";

export default function CompareDrawer() {
    const compare = useCompare();
    const navigate = useNavigate();
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (compare.ids.length === 0) {
            setItems([]);
            return;
        }
        let cancelled = false;
        Promise.all(
            compare.ids.map((id) => api.get(`/listings/${id}`).then((r) => r.data).catch(() => null))
        ).then((res) => {
            if (!cancelled) setItems(res.filter(Boolean));
        });
        return () => { cancelled = true; };
    }, [compare.ids]);

    if (compare.ids.length === 0) return null;

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[min(900px,calc(100vw-2rem))]" data-testid="compare-drawer">
            <div className="bg-[#111827] text-white border border-[#FFCC00]/30 rounded-sm shadow-2xl p-3 flex items-center gap-3">
                <GitCompareArrows className="w-5 h-5 text-[#FFCC00] flex-shrink-0" />
                <div className="flex-1 flex gap-2 overflow-x-auto min-w-0">
                    {items.map((it) => (
                        <div key={it.id} className="flex items-center gap-2 bg-white/10 rounded-sm px-2 py-1.5 text-xs flex-shrink-0" data-testid={`compare-chip-${it.id}`}>
                            {it.images?.[0] && <img src={it.images[0]} alt="" className="w-8 h-8 object-cover rounded-sm" />}
                            <div className="min-w-0">
                                <div className="font-bold truncate max-w-[140px]">{it.brand} {it.model}</div>
                                <div className="text-[10px] text-gray-300 font-mono-num">{Math.round(it.price).toLocaleString("de-DE")} €</div>
                            </div>
                            <button onClick={() => compare.remove(it.id)} className="hover:text-[#FFCC00]" data-testid={`compare-remove-${it.id}`}>
                                <X className="w-3 h-3" />
                            </button>
                        </div>
                    ))}
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                    <Button
                        onClick={() => navigate("/compare")}
                        className="bg-[#FFCC00] hover:bg-[#E6B800] text-[#111827] font-bold rounded-sm uppercase tracking-wider text-xs h-9 px-4"
                        disabled={compare.ids.length < 2}
                        data-testid="compare-open-btn"
                    >
                        Vergleichen ({compare.ids.length}/{compare.max})
                    </Button>
                    <button onClick={compare.clear} className="text-gray-400 hover:text-white text-xs font-bold uppercase tracking-wider" data-testid="compare-clear-btn">
                        Leeren
                    </button>
                </div>
            </div>
        </div>
    );
}
